
export class DataCache{
    constructor(){
        var _data;

        Object.defineProperty(this,'getData',{
            value : function(){ return _data; },
            enumerable : true 
        })

        Object.defineProperty(this,'setData',{
            value : function(d){ _data = d; },
            enumerable : true 
        })
        
    }

    // ===========
    // public 
    // -----------
    isEmpty(){
        var data = this.getData();
        return (data === undefined) || ( data === ''); 
    }

    clear(){  this.setData(undefined); }
    
    save(d){ 
        this.setData(d);
        return;
    }


}